import { ICredentials } from '../../../../../../../../app/models/Credentialing/Credentials';

import { groupBy, nestedChildrenSorting } from '../../../../../../../../app/helpers/arrayHelpers';

const partition = function <T>(arr: T[], predicate: (item: T) => boolean): [T[], T[]] {
  const yes: T[] = [];
  const no: T[] = [];
  for (const item of arr) {

    (predicate(item) ? yes : no).push(item);
  }
  return [yes, no];
};

export const groupedHumanResources = (list: any[], subCateg: string) => {
  let finalData: any = {};
  // The default formatting configuration
  const defaultFormat = [
    { item: 'expirationDate', type: 'shortDate' },
    { item: 'dateCompleted', type: 'shortDate' },
    { item: 'issuedDate', type: 'shortDate' },
    { item: 'lastUpdate', type: 'longDate' },
  ] as { item: keyof ICredentials; type: 'shortDate' | 'longDate' }[];

  switch (subCateg) {
    case 'Background Checks': {
      // Partition the list into items with requirementTypeID 211 and the rest
      const [groupA, groupB] = partition(list, item => item.requirementTypeID === 211);
      const dataA = groupBy(groupA, ['typeID'], defaultFormat);
      const dataB = groupBy(groupB, ['credentialName'], defaultFormat);
      finalData = { ...dataA, ...dataB };
      break;
    }
    case 'Drug Screens': {
      const [groupA, groupB] = partition(list, item => item.requirementTypeID === 25);
      const dataA = groupBy(groupA, ['panelTypeID'], defaultFormat);
      const dataB = groupBy(groupB, ['credentialName'], defaultFormat);
      finalData = { ...dataA, ...dataB };
      break;
    }
    case 'Identifications': {
      const [groupA, groupB] = partition(list, item => item.requirementTypeID === 48);
      const dataA = groupBy(groupA, ['stateID'], defaultFormat);
      const dataB = groupBy(groupB, ['credentialName'], defaultFormat);
      finalData = { ...dataA, ...dataB };
      break;
    }
    case 'Forms': {
      const [groupA, groupB] = partition(list, item => item?.subCategory === 'Forms' && (item?.requirementTypeID === 210 || item?.requirementTypeID === 117));
      const dataA = groupBy(groupA, ['applicationCompanyID', 'disciplineID'], defaultFormat);
      const dataB = groupBy(groupB, ['credentialName'], defaultFormat);
      finalData = { ...dataA, ...dataB };
      break;
    }
    case 'ClinicalQualifications': {
      const [groupA, groupB] = partition(
        list,
        item => item.requirementTypeID === 81 || item.requirementTypeID === 215,
      );
      const dataA = groupBy(groupA, ['credentialName'], [
        { item: 'dateCompleted', type: 'shortDate' },
        { item: 'lastUpdate', type: 'longDate' },
      ]);
      const dataB = groupBy(groupB, ['credentialName'], defaultFormat);
      finalData = { ...dataA, ...dataB };
      break;
    }
    default:
      finalData = {};
  }
  return finalData;
};

export const childSorting = (list: any[], lookups?: any[]) => {
  let finalData: any[] = [];
  if (list.length && lookups) {
    if (
      lookups
        .filter(p => p.requirementTypeID === list[0].requirementTypeID)
        .filter(l => l.lookUpField === 'ExpirationDate').length
    ) {
      finalData = nestedChildrenSorting<keyof ICredentials>(list, [
        { item: 'expirationDate', type: 'shortDate' },
        { item: 'lastUpdate', type: 'longDate' },
      ]);
    } else {
      finalData = nestedChildrenSorting<keyof ICredentials>(list, [{ item: 'lastUpdate', type: 'longDate' }]);
    }
  }
  return finalData;
};
